// 非表示にしたいタブ
export const DISABLED_TAB: string[] = [
  // 'home', // ホーム
  // 'insert', // 挿入
  // 'pageLayout', // ページレイアウト
  'formulas', // 数式
  'data', // データ
  'view', // 表示
  'settings', // 設定
  'tableDesign', // テーブル ツール
  'pictureDesign', // 図の形式
  'shapeDesign', // 図形の書式
  'pictureShapeDesign', // 図の形式
  'slicerDesign', // スライサー
  'timelineDesign', // タイムライン
  'chartDesign', // チャート ツール
  'formulaSparkLineDesign', // デザイン
  'sparkLineDesign', // スパークライン
  'barcodeDesignId', // バーコード
  'pivotTableAnalyze', // ピボットテーブル分析
  'pivotTableDesign', // デザイン
  'tableSheetDesign', // デザイン
  'tableSheetColumnSetting', // 列の設定
];

// マッピング制限プロパティの定数
export const MAPPING_RESTRICTION = {
  NOTHING: '0', // 制限なし
  ONLY: '1', // 他カテゴリ項目と明細範囲に同居不可
  AND_OPTION: '2', // 明細範囲にオプション項目のみ同居可能
};

// データカタログのオプション項目のカテゴリID
export const OPTION_CATEGORY_ID = 999000;
